import { useIntl } from 'react-intl';

import { documentManagementUrl } from '../lib/decks.ts';
import type { StudyFeedback } from '../lib/study.ts';

export function StudyReference({
  deckSlug,
  reference,
}: {
  deckSlug: string;
  reference: NonNullable<StudyFeedback['reference']>;
}) {
  const intl = useIntl();
  return (
    <div className="grid gap-1.5 text-sm text-muted-foreground">
      <p>
        {intl.formatMessage({ id: 'web.study.sourceReference' })}:{' '}
        <strong>{reference.title}</strong>
      </p>
      <p>
        {intl.formatMessage(
          { id: 'web.study.sourcePage' },
          { page: reference.page },
        )}
      </p>
      {!reference.hasLocalCopy ? (
        <>
          <p>{intl.formatMessage({ id: 'web.study.sourceMissing' })}</p>
          <a
            href={documentManagementUrl(
              deckSlug,
              reference.referenceDocumentId,
            )}
          >
            {intl.formatMessage({ id: 'web.study.sourceUpload' })}
          </a>
        </>
      ) : null}
    </div>
  );
}
